import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

function Note() {

    const selectedNote = useSelector((state) => state.questions.selectedNote)

    return(
        <div className='d-flex flex-row flex-wrap light-gray italics py-3 pl-3 pr-3'>{selectedNote}</div>
    )
}

export default Note